var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0044 33.8417C11.2084 38.0517 18.7944 38.0517 23.9964 33.8417C29.2004 29.6317 30.5204 22.4257 27.1284 16.7497L17.3484 2.22966C16.5084 0.979656 14.7744 0.623655 13.4764 1.43566C13.1506 1.64011 12.8712 1.91059 12.6564 2.22966L2.8704 16.7497C-0.519604 22.4257 0.800395 29.6317 6.0044 33.8417Z",
    stroke: "#22D3EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill3);
export default __webpack_public_path__ + "static/media/bill-3.b4882ebff8f1f06614fccdd1b631460d.svg";
export { ForwardRef as ReactComponent };